import { Navbar, Footer } from '../components/Balsuite';

const sections = [
  {
    title: '1. Information We Collect',
    content: `We collect information you provide directly to us, such as when you create an account, submit a form, or contact us for support. This includes name, email address, company name, job title, payment information (processed securely via third-party providers), and usage data about how you interact with the platform.\n\nWe also collect information automatically when you use Balsuite, including log data (IP address, browser type, pages visited), device identifiers, and cookies.`,
  },
  {
    title: '2. How We Use Your Information',
    content: `We use the information we collect to provide, maintain, and improve our services; process transactions and send related information; send technical notices and support messages; respond to your comments and questions; send marketing communications (you can opt out at any time); monitor and analyse trends and usage; and detect and prevent fraudulent transactions and other illegal activities.`,
  },
  {
    title: '3. Data Storage and Security',
    content: `We store your data on secure servers and use industry-standard encryption (TLS/SSL) for all data in transit. Data at rest is encrypted using AES-256. We retain your data for as long as your account is active or as needed to provide services.\n\nWe follow security best practices including regular audits, access controls, and employee training on data handling.`,
  },
  {
    title: '4. Sharing of Information',
    content: `We do not sell, trade, or rent your personal information to third parties. We may share your information with service providers who assist in our operations (hosting, payment processing, analytics), business partners with your consent, and law enforcement or regulatory bodies when required by law. All third-party providers are contractually required to keep your information confidential and secure.`,
  },
  {
    title: '5. Your Rights',
    content: `Depending on your location, you may have the right to access a copy of the personal data we hold about you; request correction of inaccurate data; request deletion of your personal data; receive your data in a structured, machine-readable format (data portability); and object to certain types of processing.\n\nTo exercise any of these rights, please contact us at contact@balvirt.com.`,
  },
  {
    title: '6. Cookies',
    content: `We use cookies and similar tracking technologies to enhance your experience. Please see our Cookie Policy for details on what cookies we use and how to manage them.`,
  },
  {
    title: '7. Changes to This Policy',
    content: `We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting a notice on our website or sending you an email. Your continued use of Balsuite after changes become effective constitutes your acceptance of the updated policy.`,
  },
  {
    title: '8. Contact Us',
    content: `If you have any questions about this Privacy Policy, please contact us at:\n\nEmail: contact@balvirt.com\nWebsite: https://balvirt.com`,
  },
];

export default function PrivacyPolicyPage() {
  const lastUpdated = new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="balsuite-page">
      <Navbar />
      <main style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 2rem 3rem' }}>
        <div style={{ marginBottom: '3rem' }}>
          <span className="sec-label">Legal</span>
          <h1 className="sec-h2" style={{ marginTop: '0.5rem' }}>Privacy Policy</h1>
          <p style={{ color: 'var(--t3)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Last updated: {lastUpdated}</p>
          <p className="sec-sub" style={{ marginTop: '1rem', maxWidth: '600px' }}>
            At Balvirt Technologies, we take your privacy seriously. This policy explains how we collect,
            use, and protect your information when you use Balsuite.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {sections.map(s => (
            <div key={s.title} style={{ borderLeft: '3px solid rgba(99,102,241,0.3)', paddingLeft: '1.5rem' }}>
              <h2 style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 700, fontSize: '1.05rem', color: 'var(--t1)', marginBottom: '0.75rem' }}>
                {s.title}
              </h2>
              <div style={{ fontSize: '0.9rem', color: 'var(--t2)', lineHeight: '1.85', whiteSpace: 'pre-line' }}>
                {s.content}
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '3rem', padding: '1.5rem', background: 'var(--bg2)', borderRadius: '12px', fontSize: '0.875rem', color: 'var(--t2)' }}>
          Also see our{' '}
          <a href="/cookies" style={{ color: 'var(--primary)', fontWeight: 600 }}>Cookie Policy</a>
          {' '}and{' '}
          <a href="#" style={{ color: 'var(--primary)', fontWeight: 600 }}>Terms of Service</a>.
        </div>
      </main>
      <Footer />
    </div>
  );
}
